/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TrackAddedToPlaylistNotificationActionData } from './TrackAddedToPlaylistNotificationActionData';
import {
    TrackAddedToPlaylistNotificationActionDataFromJSON,
    TrackAddedToPlaylistNotificationActionDataFromJSONTyped,
    TrackAddedToPlaylistNotificationActionDataToJSON,
} from './TrackAddedToPlaylistNotificationActionData';

/**
 * 
 * @export
 * @interface TrackAddedToPlaylistNotificationAction
 */
export interface TrackAddedToPlaylistNotificationAction {
    /**
     * 
     * @type {string}
     * @memberof TrackAddedToPlaylistNotificationAction
     */
    specifier: string;
    /**
     * 
     * @type {string}
     * @memberof TrackAddedToPlaylistNotificationAction
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof TrackAddedToPlaylistNotificationAction
     */
    timestamp: number;
    /**
     * 
     * @type {TrackAddedToPlaylistNotificationActionData}
     * @memberof TrackAddedToPlaylistNotificationAction
     */
    data: TrackAddedToPlaylistNotificationActionData;
}

/**
 * Check if a given object implements the TrackAddedToPlaylistNotificationAction interface.
 */
export function instanceOfTrackAddedToPlaylistNotificationAction(value: object): value is TrackAddedToPlaylistNotificationAction {
    let isInstance = true;
    isInstance = isInstance && "specifier" in value && value["specifier"] !== undefined;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function TrackAddedToPlaylistNotificationActionFromJSON(json: any): TrackAddedToPlaylistNotificationAction {
    return TrackAddedToPlaylistNotificationActionFromJSONTyped(json, false);
}

export function TrackAddedToPlaylistNotificationActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackAddedToPlaylistNotificationAction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'specifier': json['specifier'],
        'type': json['type'],
        'timestamp': json['timestamp'],
        'data': TrackAddedToPlaylistNotificationActionDataFromJSON(json['data']),
    };
}

export function TrackAddedToPlaylistNotificationActionToJSON(value?: TrackAddedToPlaylistNotificationAction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'specifier': value.specifier,
        'type': value.type,
        'timestamp': value.timestamp,
        'data': TrackAddedToPlaylistNotificationActionDataToJSON(value.data),
    };
}

